import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'

import { filter, find } from 'lodash'

import React from 'react'
import { EntitiesTable } from './components'

const AuditAnswers = ({
  activity,
  setCurrentTab,
  auditorAnswerEquals,
  activityName,
  isResult = false,
}) => {
  const governanceProject = activity?.governanceProject
  const isResultState = isResult && activity?.contestation
  const question = activity?.governanceProjectQuestion
  const questionRadioFields = question?.questionAlternatives?.map((item) => ({
    label: item?.title,
    value: item?.id?.toString(),
  }))

  const auditStage = isResultState
    ? activity?.stageContestation
    : activity?.governanceProjectCompanyStage

  const auditEntities = auditStage?.governanceProjectAuditEntities

  const nonConformities = filter(auditEntities, { kind: 'non_conformity' })
  const improvements = filter(auditEntities, { kind: 'improvement' })

  const auditorAnswer = find(auditEntities, {
    kind: isResultState ? 'answer_contestation' : 'answer_audit',
  })

  const handleContest = () => {
    if (!!setCurrentTab) {
      setCurrentTab('contestation')
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper variant="outlined">
          <Box display="flex" flexDirection="column" p={2} gap={2}>
            <Typography variant="h4" gutterBottom>
              {activityName}
            </Typography>
            <Typography variant="h6">{question?.question}</Typography>
          </Box>
          <Box p={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box display="flex" flexDirection="column" gap={2}>
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    Resposta {isResult ? 'Final' : 'da Auditoria'}
                  </Typography>
                  <RadioGroup value={auditorAnswer?.entityId?.toString() || ''}>
                    {questionRadioFields?.map((field) => (
                      <FormControlLabel
                        key={field?.value}
                        value={field?.value}
                        control={<Radio />}
                        label={field?.label}
                        disabled
                      />
                    ))}
                  </RadioGroup>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="textSecondary" gutterBottom>
                  Parecer {isResult ? 'final' : 'do auditor'}
                </Typography>
                <TextField
                  value={auditorAnswer?.description || ''}
                  minRows={10}
                  multiline
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="textSecondary" gutterBottom>
                  Não conformidades
                </Typography>
                <EntitiesTable entities={nonConformities} />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="textSecondary" gutterBottom>
                  Oportunidades de melhorias
                </Typography>
                <EntitiesTable entities={improvements} />
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Grid>

      {!isResult && (
        <Grid item xs={12}>
          <Paper>
            <Tooltip
              title={
                auditorAnswerEquals
                  ? 'Não é possível realizar uma contestação quando a resposta do auditor é igual à da organização.'
                  : ''
              }
            >
              <Box display="flex" justifyContent="flex-end" p={2} gap={2}>
                <Button
                  onClick={handleContest}
                  variant="contained"
                  color="primary"
                  disabled={
                    !governanceProject?.underContestation ||
                    governanceProject?.underContestationAudit ||
                    auditorAnswerEquals
                  }
                >
                  Contestar
                </Button>
              </Box>
            </Tooltip>
          </Paper>
        </Grid>
      )}
    </Grid>
  )
}

export default AuditAnswers
